import React from "react";
import FAQHome from "../Pages/FAQPage/FAQHome";
import { Faq } from "../Pages/FAQPage/FAQ";
import Steps from "../Pages/FAQPage/Steps";


const FAQPage = () => {
    return (
        <>
            <FAQHome/>
            <Steps/>
            <Faq/>
        </>
    )
}

export default FAQPage;